import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "O pingvinih in OS-ih",
  "description": "",
  "published": "2006-05-01T00:00:00.000Z",
  "redirect_from": ["/blog/o-pingvinih-in-osih/swizec/424"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Pred nekaj dnevi, natancneje v cetrtek, se je zacelo dolgo popotovanje, potovanje po cudnih dezelah pingvinoh in operacijskih sistemov. Po kratkem in bolecem praznenju osnovnega diska je prisla dolga bitka za oblast in obstoj z instalacijo svezega `}<a parentName="p" {...{
        "href": "http://gentoo.org"
      }}>{`Gentoo-ja`}</a>{`. Bitka je rajala priblizno tri dni, in v bistvu nekatere stvari se vedno niso kot bi morale biti. Na primer skener se vedno protestira in je neuporaben.`}</p>
    <p>{`Zacel sem tudi z delom na prvem delu Cthulhu-ja in sem kar zadovoljen z izgledom, ki se pojavlja na praznem papirju. Uspel sem zrisati prvo okence, kar je trajalo priblizno eno uro... Ce pomislim, da je v prvem delu 14 takih okenc me kar stisne pri srcu. V bistvu, ce na to priracunamo se, da barvanje enega takega okenca traja priblizno dve uri, se vidi, da bo izdelava prvega dela trajala 42 ur, kar je verjetno razlog zakaj je nov del samo enkrat na mesec. Iz drugega stalisca, povprecen tedenski delavnik je 42 ur, tako da ce bi hotel, da je strip tedenski...`}</p>
    <p>{`Narejena je bila tudi `}<a parentName="p" {...{
        "href": "http://swizec.com/index.php/mode=pages/submode=Links"
      }}>{`nova staticna`}</a>{` stran, prva v bistvu, `}<a parentName="p" {...{
        "href": "http://swizec.com/index.php/mode=pages/submode=Links"
      }}>{`njena`}</a>{` namembnost so cisto samo `}<a parentName="p" {...{
        "href": "http://swizec.com/index.php/mode=pages/submode=Links"
      }}>{`povezave.`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      